<template>
     <template v-for="my_item in Object.values(myMenu)" >
          <a-menu-item
               v-if="my_item.type === 'item' && (my_item.empresa === empresa || my_item.empresa === undefined)"
               :title="my_item.label"
               :key="my_item.key"
               @click="hide"
               :selectedKeys="[my_item.key]"
          >
               <router-link v-if="my_item.link !== null" :to="my_item.link">
                    <component v-if="my_item.icon !== null && my_item.iconType == 'antd-icon'" :is="my_item.icon" class="icon"/>
                    <v-icon v-if="my_item.icon !== null && my_item.iconType == 'oh-vue'" :name="my_item.icon" class="icon" style="margin-right: 10px; padding: 4px " />
                    <span class="label">{{ my_item.label }}</span>
               </router-link>
          </a-menu-item>
          <a-divider v-if="my_item.type === 'menu-item-header' && collapse == false">
               <component v-if="my_item.icon !== null" :is="my_item.icon" />
               {{ my_item.label }}
          </a-divider>
          <!-- <MenuItems @hide="hide" :my_item="my_item" :collapse="collapse"></MenuItems> -->
     </template>
</template>
<script>
import { addIcons } from "oh-vue-icons";
import { CoNewspaper } from "oh-vue-icons/icons";
import { itemClient } from './menu_items/menu_client';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  MailOutlined,
  DesktopOutlined,
  InboxOutlined,
  AppstoreOutlined,
  CloudOutlined,
  DollarCircleOutlined,
  ContainerOutlined,
  CustomerServiceOutlined,
  TeamOutlined
} from '@ant-design/icons-vue';
export default {
	emits:[ 'toggleSidebar' ],
	components: {
		// MenuItems
        MenuFoldOutlined,
		MenuUnfoldOutlined,
		PieChartOutlined,
		MailOutlined,
		DesktopOutlined,
		InboxOutlined,
		AppstoreOutlined,
		CloudOutlined,
		DollarCircleOutlined,
		ContainerOutlined,
		MailOutlined,
		CustomerServiceOutlined,
		TeamOutlined
    },
    props: {
	sidebarTheme: {
		type: String,
		default: 'light'
	},
	menu_align: {
		type: String,
		default: 'inline'
	},
	collapse: {
		type: Boolean,
		default: false
	},
	typeMenu: {
		type: String,
		default: ""
	}
    },
    data() {
        	return {
			openKeys: ["DASHBOARD"],
          	myMenu: [],
			selectedKeys: [1],
			isSelected: false,
			empresa: false
     	}
    },
	created() {
		addIcons(CoNewspaper)
	},
     mounted: function() {
          this.myMenu = itemClient;
          if (this.$route.meta.myCliente) {
			// this.empresa = (this.$route.meta.myCliente[0].company_type === 'person') ? false : true
			this.empresa =  false
		}
     },
	methods: {
		hide() {
			this.$emit('toggleSidebar', false)
		}
	}
}
</script>